<template>
  <Toast position="top-right" />
  <ConfirmDialog />
  <div v-if="auth.booting" class="boot-screen">
    <img src="/brand-icon.png" alt="Food Airway" />
    <ProgressSpinner stroke-width="4" />
    <p>Preparing your restaurant workspace...</p>
  </div>
  <RouterView v-else />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView, useRouter } from 'vue-router'
import ConfirmDialog from 'primevue/confirmdialog'
import ProgressSpinner from 'primevue/progressspinner'
import Toast from 'primevue/toast'
import { useAuthStore } from './stores/auth'

const auth = useAuthStore()
const router = useRouter()

async function expireSession() {
  auth.clear()
  await router.push('/login')
}

onMounted(async () => {
  window.addEventListener('restaurant-session-expired', expireSession)
  await auth.restore()
})

onUnmounted(() => window.removeEventListener('restaurant-session-expired', expireSession))
</script>
